'use client';

import React, { useContext } from 'react';
import twMerge from 'utilities/src/twMerge';
import ThemeContext from './_themeContext';

interface Props {
  children: React.ReactNode;
  className?: string;
}

export default function ShadowContainer({ children, className }: Props) {
  const { theme } = useContext(ThemeContext);
  return (
    <div className={twMerge(className, { 'mdS:drop-shadow-2xl mdS:hover:drop-shadow-none': theme === 'dark' })}>
      {children}
      <div className="shadow-lv5 mdS:hidden absolute left-0 top-0 -z-10 h-[calc(100%-2.5rem)] w-full rounded-2xl" />
    </div>
  );
}
